export const normalizePosIntegration = code => {
  const raw = String(code || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
  if (raw === "wulooj" || raw === "wulooj-pos") {
    return "wulooj-pos"
  }
  if (raw === "foodics") {
    return "foodics"
  }
  if (raw === "syrve") {
    return "syrve"
  }
  return ""
}

export const resolvePosIntegrationFromContext = ({
  brandId = "",
  allowedBrands = [],
} = {}) => {
  const selectedId = String(brandId || "").trim()
  if (selectedId) {
    const brand = allowedBrands.find(
      row => String(row?._id) === selectedId
    )
    return normalizePosIntegration(brand?.integration)
  }
  if (allowedBrands.length === 1) {
    return normalizePosIntegration(allowedBrands[0]?.integration)
  }
  return ""
}

export const resolvePosIntegrationForBranch = ({
  branch = {},
  allowedBrands = [],
  fallbackIntegration = "",
} = {}) => {
  const brandRef = branch?.brand
  const brandId =
    typeof brandRef === "object" && brandRef !== null
      ? brandRef._id
      : brandRef
  if (brandId) {
    const brand = allowedBrands.find(
      row => String(row?._id) === String(brandId)
    )
    const resolved = normalizePosIntegration(brand?.integration)
    if (resolved) {
      return resolved
    }
  }
  const fallback = normalizePosIntegration(fallbackIntegration)
  if (fallback) {
    return fallback
  }
  if (allowedBrands.length === 1) {
    return normalizePosIntegration(allowedBrands[0]?.integration)
  }
  return ""
}

export const isPosBranchLinked = (item, posIntegration) => {
  const ps = item?.posSettings || {}
  if (posIntegration === "wulooj-pos") {
    return !!ps.wuloojBranchId
  }
  if (posIntegration === "foodics") {
    return !!ps.foodicsBranchId
  }
  if (posIntegration === "syrve") {
    return !!ps.organizationId
  }
  return !!(ps.wuloojBranchId || ps.foodicsBranchId || ps.organizationId)
}

export const getPosBranchLinkColumnLabel = (posIntegration, t) => {
  if (posIntegration === "wulooj-pos") {
    return t("Wulooj Branch Id")
  }
  if (posIntegration === "foodics") {
    return t("Foodics Branch Id")
  }
  if (posIntegration === "syrve") {
    return t("Organization Id")
  }
  return t("POS Branch")
}

export const getBranchSyncListColumns = posIntegration => {
  const base = ["sno", "name", "branchRef", "countryCode"]

  if (posIntegration === "wulooj-pos") {
    return [...base, "posBranchLink", "lastUpdated", "action"]
  }
  if (posIntegration === "foodics") {
    return [...base, "posBranchLink", "paymentType", "lastUpdated", "action"]
  }
  if (posIntegration === "syrve") {
    return [
      ...base,
      "organizationId",
      "terminalGroup",
      "webhook",
      "paymentType",
      "lastUpdated",
      "action",
    ]
  }
  return [...base, "posBranchLink", "lastUpdated", "action"]
}

/** Credentials via Settings → Integrations (not POS Settings → API key). */
export const INTEGRATION_CREDENTIAL_POS_CODES = ["wulooj-pos", "foodics"]

export const isTenantPosIntegrationConnected = (row = {}) => {
  if (!row || row.isEnabled === false) {
    return false
  }
  return String(row.status || "").toLowerCase() === "connected"
}

/** Per-country API key tab is Syrve-style only; hide for integration-managed POS. */
export const shouldShowLegacyPosApiKeyTab = (integrationsByCode = {}) => {
  for (const code of INTEGRATION_CREDENTIAL_POS_CODES) {
    if (isTenantPosIntegrationConnected(integrationsByCode[code])) {
      return false
    }
  }
  return true
}
